import type { Owner } from "common/Database";
import * as React from "react";
import { shallowEqual } from "react-redux";
import { getAppOwner } from "store/types";

import { useBuilderSelector } from "./use-builder-selector";

export function useAppOwner(appID: string): Owner | undefined {
    const { userData, organizations } = useBuilderSelector(s => {
        return {
            userData: s.userData,
            organizations: s.organizations,
        };
    }, shallowEqual);

    const owner = React.useMemo(() => {
        return getAppOwner(appID, userData, organizations);
    }, [appID, userData, organizations]);

    return owner;
}
